import type { IconProps } from '@src/components/icons/IconProps';

/** A parcel — gifts sent by post. */
export function PackageIcon({ className }: IconProps) {
  return (
    <svg
      className={className}
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M3 7.5 12 3l9 4.5v9L12 21l-9-4.5v-9Z" />
      <path d="M12 12v9" />
      <path d="M12 12 21 7.5" />
      <path d="M12 12 3 7.5" />
      <path d="M7.5 5.25 16.5 9.75" />
    </svg>
  );
}
